import React from 'react';
import { Typography } from '../Typography/Typography';
import * as S from './Loader.styles';
const getAriaLive = (isFullscreen, politeness) => {
  if (politeness) {
    return politeness;
  }
  return isFullscreen ? 'assertive' : 'polite';
};
const Loader = /*#__PURE__*/React.forwardRef(({
  title,
  description,
  loading,
  isFullscreen = false,
  politeness
}, ref) => {
  if (!loading) {
    return null;
  }
  const OverlayContainer = isFullscreen ? S.LoaderOverlay : React.Fragment;
  const ariaLive = getAriaLive(isFullscreen, politeness);
  return /*#__PURE__*/React.createElement(OverlayContainer, isFullscreen ? {
    'data-testid': 'loader-overlay'
  } : null, /*#__PURE__*/React.createElement(S.LoaderContainer, {
    ref: ref,
    role: "progressbar",
    "aria-busy": true,
    "aria-live": ariaLive
  }, /*#__PURE__*/React.createElement(S.StyledLoader, {
    $hasMarginBottom: Boolean(title || description)
  }), !!title ? /*#__PURE__*/React.createElement(Typography, {
    variant: "headline",
    size: "small"
  }, title) : null, !!description ? /*#__PURE__*/React.createElement(Typography, {
    variant: "ui",
    size: "large"
  }, description) : null));
});
export { Loader };